import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { FullListComponent } from '../wordpress-resources/full-list/full-list.component';
import { FeatureComponent } from '../wordpress-resources/feature/feature.component';

@Component({
  standalone: true, 
  selector: 'resources',
  templateUrl: './resources.component.html',
  styleUrls: ['./resources.component.css'],
  imports: [
    FeatureComponent,
    FullListComponent,
    RouterModule
  ]
})

export class ResourcesComponent implements OnInit {
  allPosts : any;
  id: any;
  
  constructor(private route: ActivatedRoute) {
    this.allPosts = [];
    this.id = 67;
  }

  ngOnInit(): void {
    this.route.paramMap.subscribe(params => {
      if (params.get('id')) {
        this.id = params.get('id'); // This will be null if no id is provided
        console.log ("id passed in is: " + this.id);
      } else {
        this.id=67;
        //console.log ("assuming id is 67");
      }
    });
  }
} 
